import styled from 'styled-components'

import { helpers } from 'styles'

export const Container = styled.div`
	font-size: ${helpers.font.size.subheader};
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 32px 0;
`
